import React from "react";
import ContainerHeader from "codeArt/components/ContainerHeader";
import { Page, Refreshable, theme } from "codeArt/components/Base";
import { Consumables, costKeepId, getConsumable } from "./constant";
import { ProgressBar } from "codeArt/components/Progress";
import { Focus, getConsumableImage } from "./common";
import Portal from "codeArt/components/Portal";
import { DataContext } from "app/data/context";
import { Shifts, Teams } from "app/constant";
import { getRandom } from "app/components/common";
import DataGrid, { SearchBar } from "codeArt/components/dataGrid";
import Modal from "codeArt/components/Modal";
import Select from "codeArt/components/Select";
import Table from "codeArt/components/accessory/table";
import { runtime, threePosition, Util } from "codeArt/common";

export default class Cost extends Page {
  constructor(props) {
    super(props);
    this.keepId = costKeepId;
  }

  getTracker() {
    return {
      get: () => {
        return { path: "device/detail/quality", value: "损耗" };
      }
    };
  }

  renderBody() {
    let { id } = this.props;
    return <Body id={id} />;
  }
}

class Body extends Focus {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state
    };
  }

  body() {
    return [<Vulnerable key="vulnerable" />, <Consumable key="consumable" />];
  }
}

class Vulnerable extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let data = DataContext.get("DEVICE_COST_VULNERABLE");
    return (
      <Portal {...Portal.detailFlatProps} title="易损件">
        <div className="row">
          {data.map((t, i) => {
            return VulnerableItem(t, i);
          })}
        </div>
      </Portal>
    );
  }
}

export function getLifeColor(value) {
  if (value >= 0.8) return theme.color.danger;
  if (value >= 0.5) return theme.color.warning;

  return theme.color.success;
}

export const VulnerableItem = (function() {
  function renderLife(data) {
    let loss = data.value / data.life;
    let color = getLifeColor(loss);
    return (
      <div
        className={`d-flex flex-column justify-content-center align-items-start`}
      >
        <label className="c-text-s2 m-text-dark75">{`${data.value}/${data.life} ${data.unit}`}</label>
        <ProgressBar
          foreground={color}
          background={"#e9ecef"}
          value={loss * 100}
          width="100%"
        />
      </div>
    );
  }

  function renderCard(data, index, cardClassName) {
    return (
      <div
        key={`vulnerable-${index}`}
        className="col-sm-12 col-md-4 col-lg-4 my-3"
      >
        <div
          className={`jr-card jr-card-widget p-4 card ${cardClassName || ""}`}
        >
          <div className="media align-items-center flex-nowrap">
            <div className="mr-3">
              <img
                width={50}
                height={50}
                src={require(`./images/${data.image}.png`)}
              />
            </div>
            <div className="media-body">
              {renderLife(data)}
              <div className="d-flex flex-row justify-content-between align-items-center mt-1">
                <p className="text-grey mb-0 c-text-s1d5">{data.name}</p>
                <p className="text-grey mb-0 c-text-s1d5">{data.sn}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return renderCard;
})();

class Consumable extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let data = DataContext.get("DEVICE_COST_CONSUMABLE");
    return (
      <Portal {...Portal.detailFlatProps} title="耗材">
        <div className="row">
          <div className="col-12">
            <p className="c-text-s2 m-text-dark50 mb-0 mt-2">
              总损耗 / 平均损耗
            </p>
          </div>

          {data.map((t, i) => {
            return renderConsumableItem(t, i, () => {
              this.modal.open(t.type);
            });
          })}
        </div>
        <ConsumableModal
          ref={r => {
            this.modal = r;
          }}
        />
      </Portal>
    );
  }
}

const renderConsumableItem = (function() {
  function renderLife(data) {
    return (
      <div
        className={`d-flex flex-column justify-content-center align-items-start`}
      >
        <label className="c-text-s2 m-text-dark75 c-lh-1 mb-2">{`${threePosition(
          data.total
        )} ${data.unit}`}</label>
        <label className="c-text-s2 m-text-dark50 c-lh-1 mb-2">{`${threePosition(
          data.average
        )} ${data.unit}/班次`}</label>
      </div>
    );
  }

  function renderCard(data, index, onClick) {
    return (
      <div key={`${index}`} className="col-sm-12 col-md-4 col-lg-4 my-3">
        <div className="jr-card jr-card-widget p-4 card jr-card-full jr-dot-arrow-hover">
          <div className="media align-items-center flex-nowrap">
            <div className="mr-3">
              <img
                width={50}
                height={50}
                src={getConsumableImage(data.image)}
              />
            </div>
            <div className="media-body">
              {renderLife(data)}
              <div className="d-flex flex-row justify-content-between align-items-center">
                <p className="text-grey mb-0 c-text-s1d5 c-lh-1">{data.name}</p>
              </div>
            </div>
          </div>
          <div className="jr-dot-arrow">
            <div
              className="bg-blue jr-hover-arrow"
              onClick={() => {
                if (onClick) onClick();
              }}
            >
              <i className="zmdi zmdi-long-arrow-right text-white" />
            </div>
            <div className="jr-dot">
              <i className="zmdi zmdi-more-vert text-blue" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return renderCard;
})();

class ConsumableModal extends React.Component {
  constructor(props) {
    super(props);
    this.searchArg = {};
    this.state = {
      data: []
    };
  }

  open(type) {
    let data = this.getData(type);
    this.setState({ type, data }, () => {
      this.modal.open();
    });
  }

  close() {
    this.modal.close();
  }

  getData(type, shift, team) {
    let base = [
      { type: Consumables.TrayPaper.Type, value: 5272, float: [100, 500] },
      { type: Consumables.ColdGlue.Type, value: 51, float: [1, 20] },
      { type: Consumables.HotGlue.Type, value: 55, float: [1, 20] },
      { type: Consumables.ClothTape.Type, value: 632, float: [50, 100] },
      { type: Consumables.Blade.Type, value: 13, float: [1, 20] },
      { type: Consumables.Bead.Type, value: 5325, float: [100, 300] },
      { type: Consumables.Glycerin.Type, value: 24, float: [1, 30] },
      { type: Consumables.Spices.Type, value: 13, float: [1, 20] },
      { type: Consumables.Tow.Type, value: 723, float: [50, 100] }
    ];

    let obj = base.find(t => t.type == type);
    if (!obj) return [];

    let data = [];
    Shifts.forEach(s => {
      Teams.forEach(t => {
        if (s.Id && t.Id) {
          for (var i = 0; i < 7; i++) {
            data.push({
              Index: i,
              Consumption: obj.value + getRandom(obj.float[0], obj.float[1]),
              Time: `07/2${i}`,
              Shift: s.Id,
              Team: t.Id,
              Id: `${s.Id}_${t.Id}_07/2${i}`
            });
          }
        }
      });
    });

    data = Util.order(data, t => t.Index);

    if (shift) data = data.filter(t => t.Shift == shift);
    if (team) data = data.filter(t => t.Team == team);
    return data;
  }

  search(v) {
    let { type } = this.state;
    let data = this.getData(type, v.Shift, v.Team);
    this.setState({ data });
  }

  getShiftGroupTip(data) {
    let team = Teams.find(t => t.Id == data.Team) || {};
    let shift = Shifts.find(t => t.Id == data.Shift) || {};

    return `${shift.Name}/${team.Name}`;
  }

  getConsumptionTip(data) {
    let { type } = this.state;
    let unit = getConsumable(type).Unit;

    return {
      total: `${data.Consumption * 3} ${unit}`,
      average: `${data.Consumption} ${unit}`
    };
  }

  pc(data) {
    return (
      <Modal
        title={"耗材明细"}
        ref={r => {
          this.modal = r;
        }}
        size="md"
        containerFull={true}
      >
        <DataGrid
          className={DataGrid.modalClassName}
          data={{ rows: data }}
          searchMaster="table"
          page={false}
          scrollable={true}
          columns={[
            {
              field: "Consumption",
              label: "总损耗量",
              align: "left",
              width: "auto",
              component: data => {
                return this.getConsumptionTip(data).total;
              }
            },
            {
              field: "Consumption",
              label: "损耗量 每分钟",
              align: "center",
              width: "auto",
              component: data => {
                return this.getConsumptionTip(data).average;
              }
            },
            { field: "Time", label: "时间", align: "left", width: "150px" },
            {
              field: "ShiftGroup",
              label: "班次/工作组",
              align: "center",
              width: "150px",
              component: data => {
                return this.getShiftGroupTip(data);
              }
            }
          ]}
          toolbar={
            <SearchBar
              searchMaster="table"
              title="搜索"
              onClick={v => {
                this.search(v);
              }}
            >
              <Select
                emptyable={false}
                field="Shift"
                label="班次"
                options={Shifts.map(t => {
                  return { value: t.Id, text: t.Name };
                })}
                width={200}
                variant="outlined"
                size={"small"}
                slave="table"
              />
              <Select
                emptyable={false}
                field="Team"
                label="工作组"
                options={Teams.map(t => {
                  return { value: t.Id, text: t.Name };
                })}
                width={200}
                variant="outlined"
                size={"small"}
                slave="table"
              />
            </SearchBar>
          }
        />
      </Modal>
    );
  }

  mobileSearch(v, field) {
    this.searchArg[field] = v;
    this.search(this.searchArg);
  }

  mobile(data) {
    return (
      <Modal
        title={"耗材明细"}
        ref={r => {
          this.modal = r;
        }}
        size="md"
      >
        <SearchBar searchMaster="table" title="搜索" className="mt-3">
          <Select
            emptyable={false}
            field="Shift"
            label="班次"
            options={Shifts.map(t => {
              return { value: t.Id, text: t.Name };
            })}
            width={200}
            variant="outlined"
            size={"small"}
            slave="table"
            mobileable={true}
            onChange={v => {
              this.mobileSearch(v, "Shift");
            }}
          />
          <Select
            emptyable={false}
            field="Team"
            label="工作组"
            options={Teams.map(t => {
              return { value: t.Id, text: t.Name };
            })}
            width={200}
            variant="outlined"
            size={"small"}
            slave="table"
            mobileable={true}
            onChange={v => {
              this.mobileSearch(v, "Team");
            }}
          />
        </SearchBar>

        <Table
          scrollable={false}
          className="w-100 my-3"
          columns={[
            {
              field: "Consumption",
              label: "总损耗量",
              align: "center",
              width: 3,
              component: data => {
                return this.getConsumptionTip(data).total;
              }
            },
            {
              field: "Consumption",
              label: "损耗量 每分钟",
              align: "center",
              width: 3,
              component: data => {
                return this.getConsumptionTip(data).average;
              }
            },
            { field: "Time", label: "时间", align: "center", width: 3 },
            {
              field: "ShiftGroup",
              label: "班次/工作组",
              align: "center",
              width: 3,
              component: data => {
                return this.getShiftGroupTip(data);
              }
            }
          ]}
          data={{
            rows: [...data]
          }}
        />
      </Modal>
    );
  }

  render() {
    let { data } = this.state;
    return runtime.mobile ? this.mobile(data) : this.pc(data);
  }
}
